"use client"

import React, { useEffect, useState } from "react";

function Metrics(){

    const[million, setMillion] = useState(10.0)

    const[growth, setGrowth] = useState(30)

    const[satisfaction, setSatifaction] = useState(85)


    useEffect(() => {
        const incrementMillion = () => {
            if (million < 11.4) {
              setMillion(Number((million + 0.1).toFixed(2)));
            }
          };
      
          const interval = setInterval(incrementMillion, 100);
      
          return () => {
            clearInterval(interval); 
          };
    },[million])

    useEffect(() => {
        const incrementGrowth = () => {
            if (growth < 45) {
              setGrowth(Number((growth + 1)));
            }
          };
      
          const interval = setInterval(incrementGrowth, 100); 
      
          return () => {
            clearInterval(interval); 
          };
    },[growth])

    useEffect(() => {
        const incrementSatisfaction = () => {
            if (satisfaction < 100) {
              setSatifaction(Number((satisfaction + 1)));
            }
          };
      
          const interval = setInterval(incrementSatisfaction, 100); 
      
          return () => {
            clearInterval(interval); 
          };
    },[satisfaction])


    return(
        <div className="flex flex-col justify-center items-center sm:pt-36 text-[#042040]"> 

        <div className="flex justify-center items-center mx-auto gap-10 lg:gap-20 mb-10 lg:mb-20 flex-col lg:flex-row">
            <div className="bg-white col-start-1 justify-self-center md:justify-self-end fadeIn1 w-[350px] sm:w-[450px] lg:w-[500px] h-[220px] sm:h-[250px] lg:h-[300px] rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col justify-center items-center overflow-hidden relative group">
                <p className="text-6xl sm:text-8xl font-bold pt-4 px-5 text-[#042040] relative z-2 overflow-hidden">{million}M
                <span className="w-fit h-fit overflow-hidden relative">
                    <span className="text-white">€</span>
                    <span className="absolute top-1/2 group-hover:top-[150px] transform -translate-y-1/2 left-0 duration-200 ease-in py-3">€</span>
                    <span className="absolute -top-12 group-hover:top-1/2 transform -translate-y-1/2 -left-5 text-5xl sm:text-7xl duration-200 ease-in">💰</span>
                </span>
                </p>
                <p className="text-left mt-5 px-5 text-md sm:text-lg lg:text-xl text-center lg:text-left">de <span className="font-bold text-[#042040]">financements</span> obtenus pour nos clients en 2023</p>                
            </div>

            <div className="bg-white col-start-2 justify-self-center md:justify-self-start fadeIn1 w-[350px] sm:w-[450px] lg:w-[400px] h-[220px] sm:h-[250px] lg:h-[300px] rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col justify-center items-center overflow-hidden relative group">
                <p className="text-6xl sm:text-8xl font-bold pt-4 px-5 text-[#042040] relative z-2 relative">
                    +{growth}%
                    <span className="text-5xl sm:text-7xl absolute -right-5 -top-1/2 transform translate-y-1/2 opacity-0 group-hover:opacity-100 rotate-[-10deg] group-hover:rotate-[10deg] scale-0 group-hover:scale-100 duration-200 ease-in">📈</span> 

                </p>
                <p className="text-left mt-5 px-5 text-md sm:text-lg lg:text-xl text-center lg:text-left">de croissance du <span className="font-bold text-[#042040]">CA</span> de nos clients</p>   
                   
            </div>
        </div>

        <div className="flex justify-center items-center mx-auto gap-10 lg:gap-20 flex-col lg:flex-row mb-[10px]">
            <div className="bg-white col-start-3 justify-self-center md:justify-self-end fadeIn1  w-[350px] sm:w-[450px] lg:w-[400px] lg:w-[350px] h-[220px] sm:h-[250px] lg:h-[300px] rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col justify-center items-center overflow-hidden  group">
                <p className="text-6xl sm:text-8xl font-bold pt-4 px-5 text-[#042040] relative z-2 relative">
                    {satisfaction}% 
                    <span className="text-5xl sm:text-7xl absolute -right-5 -top-1/2 transform translate-y-1/2 opacity-0 group-hover:opacity-100 rotate-[-10deg] group-hover:rotate-[10deg] scale-0 group-hover:scale-100 duration-200 ease-in">🤩</span> 
                </p>
                <p className="text-[#042040] text-left mt-5 px-5 text-md sm:text-lg lg:text-xl text-center lg:text-left">des clients <span className="font-bold">satisfaits</span> par notre accompagnement</p>       
                        
            </div>

            

            <div className="bg-white justify-self-center md:justify-self-start fadeIn1 w-[350px] sm:w-[450px] lg:w-[500px] h-[220px] sm:h-[250px] lg:h-[300px] rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col justify-center items-center overflow-hidden group">
                <p className="text-6xl sm:text-8xl font-bold pt-4 px-5 text-[#042040] relative z-2 relative">
                    0
                    <span className="text-5xl sm:text-7xl absolute -right-10 -top-1/2 transform translate-y-1/2 opacity-0 group-hover:opacity-100 rotate-[-10deg] group-hover:rotate-[10deg] scale-0 group-hover:scale-100 duration-200 ease-in">🤝</span> 
                </p>
                <p className="text-left mt-5 px-5 text-md sm:text-lg lg:text-xl text-center lg:text-left"><span className="font-bold text-[#042040]">défaillance</span> de nos clients depuis le début de leur accompagnement</p>                
            </div>

        </div>

        </div>
       
    )
}

export default Metrics;